import React from 'react';
import { useInterface } from '../../context/InterfaceProvider';
import ufoBeams from './assets/ufo-beams.png';
import platform from './assets/platform.png';
import styles from './LayeredCardHero.module.css';

// The content stays mounted across interface changes, preserving image interactions.
export default function LayeredCardHero({ children }) {
  const { version } = useInterface();
  return (
    <div className={styles.hero} data-layered-card-hero>
      {version === 'simple' && (
        <>
          <img className={styles.ufo} data-hero-ufo src={ufoBeams} width="1024" height="1536" alt="" aria-hidden="true" draggable="false" />
          <img className={styles.platform} data-hero-platform src={platform} width="1774" height="887" alt="" aria-hidden="true" draggable="false" />
        </>
      )}
      <div className={styles.card} data-hero-card>{children}</div>
    </div>
  );
}
